/**
 * Data-href handler functie
 * Initialiseert links met data-href attributen zodat ze bij klikken naar de data-href URL navigeren
 *
 * @param {string} selector - CSS selector voor elementen (standaard: 'a[data-href]')
 * @returns {number} Aantal geïnitialiseerde links
 */
export default function InitDataHref(selector = 'a[data-href]') {
    // Hulpfunctie voor het afhandelen van klikken
    function handleDataHrefClick(event) {
        // Controleer of data-href attribuut bestaat
        const dataHref = this.getAttribute('data-href');

        if (dataHref && dataHref.trim() !== '') {
            // Voorkom het standaard klikgedrag van de link
            event.preventDefault();
            // Stop alle andere event handlers
            event.stopPropagation();
            event.stopImmediatePropagation();

            // Navigeren naar de URL in data-href
            window.location.href = dataHref;
        }
    }

    // Alle elementen selecteren met het opgegeven selector
    const links = document.querySelectorAll(selector);

    // Event listener toevoegen aan elk gevonden element
    links.forEach(function (link) {
        // Verwijder ALLE bestaande event listeners door het element te clonen
        // Dit verwijdert ook jQuery event handlers
        const newLink = link.cloneNode(true);
        link.parentNode.replaceChild(newLink, link);

        // Voeg de data-href handler toe aan het nieuwe element
        newLink.addEventListener('click', handleDataHrefClick, true);
    });

    return links.length; // Aantal geïnitialiseerde links teruggeven
}